export enum CONTENT_STREAMS_ADMIN {
    /**
     * @value Remove stream
     */
    CONFIRM_DELETE = 'ADMIN.CUSTOMER.STREAMS.CONFIRM_DELETE',
    /**
     * @value Are you sure you want to delete this stream ?
     */
    CONFIRM_DELETE_DESCRIPTION = 'ADMIN.CUSTOMER.STREAMS.CONFIRM_DELETE_DESCRIPTION',
    /**
     * @value Tag
     */
    CONTENT_FILTER_CATEGORIES = 'CONTENT_FILTER_CATEGORIES',
    /**
     * @value Content settings
     */
    CONTENT_SETTINGS = 'ADMIN.CUSTOMER.STREAMS.CONTENT_SETTINGS',
    /**
     * @value Content stream
     */
    CONTENT_STREAM = 'ADMIN.NAV.MOBILE_SETTINGS_CONTENT_STREAMS',
    /**
     * @value Content type
     */
    CUSTOM_CONTENT_TYPE = 'CUSTOM_CONTENT_TYPE',
    /**
     * @value Stream deleted
     */
    DELETED = 'ADMIN.CUSTOMER.STREAMS.DELETED',
    /**
     * @value Only display content from the favorite sites of the connected user
     */
    FAVORITE_SITE_ONLY = 'ADMIN.CUSTOMER.STREAMS.FAVORITE_SITE_ONLY',
    /**
     * @value default
     */
    INSTANCE_DEFAULT = 'ADMIN.CUSTOMER.STREAMS.INSTANCE_DEFAULT',
    /**
     * @value Empty or deleted site(s)
     */
    INSTANCE_EMPTY_OR_DELETED = 'ADMIN.CUSTOMER.STREAMS.INSTANCE_EMPTY_OR_DELETED',
    /**
     * @value Source site
     */
    INSTANCE_LABEL = 'ADMIN.CUSTOMER.STREAMS.INSTANCE_LABEL',
    /**
     * @value A site is required for this stream
     */
    INSTANCE_REQUIRED = 'ADMIN.CUSTOMER.STREAMS.INSTANCE_REQUIRED',
    /**
     * @value Featured only
     */
    LIST_FEATURED_ONLY = 'WIDGET_TYPE_CONTENT-LIST_FEATURED_ONLY',
    /**
     * @value Display only content with "featured" option enabled
     */
    LIST_FEATURED_ONLY_HELP = 'WIDGET_TYPE_CONTENT-LIST_FEATURED_ONLY_HELP',
    /**
     * @value Only highlighted
     */
    LIST_HIGHLIGHTED = 'WIDGET_TYPE_CONTENT-LIST_HIGHLIGHTED',
    /**
     * @value Only show content highlighted to the connected user
     */
    LIST_HIGHLIGHTED_HELP = 'WIDGET_TYPE_CONTENT-LIST_HIGHLIGHTED_HELP',
    /**
     * @value Number of elements to display
     */
    LIST_MAX_NUMBER = 'WIDGET_TYPE_CONTENT-LIST_MAX_NUMBER',
    /**
     * @value Sites
     */
    MEDIA_PICKER_INSTANCES = 'MEDIA_PICKER_INSTANCES',
    /**
     * @value This value must be between 1 and 10.
     */
    MIN_MAX_CONTENT_DISPLAY_ERROR = 'ADMIN.CUSTOMER.STREAMS.MIN_MAX_CONTENT_DISPLAY_ERROR',
    /**
     * @value A name is required for the stream
     */
    NAME_REQUIRED = 'ADMIN.CUSTOMER.STREAMS.NAME_REQUIRED',
    /**
     * @value New stream
     */
    NEW_STREAM = 'ADMIN.CUSTOMER.STREAMS.NEW_STREAM',
    /**
     * @value Stream saved
     */
    SAVED = 'ADMIN.CUSTOMER.STREAMS.SAVED',
    /**
     * @value Select source site(s)
     * @description Select source lumapps web site option in content stream admin page
     */
    SELECT_SITES = 'ADMIN.CUSTOMER.STREAMS.SELECT_SITES',
    /**
     * @value Visible by
     */
    SETTINGS_VISIBLE_BY = 'CONTENT_SETTINGS_VISIBLE_BY',
    /**
     * @value Stream
     */
    STREAM_HEADER_TITLE = 'ADMIN.CUSTOMER.STREAMS.STREAM_HEADER_TITLE',
    /**
     * @value Use sibling and child sites of the default site
     */
    USE_DEFAULT_SITE = 'ADMIN.CUSTOMER.STREAMS.USE_DEFAULT_SITE',
    /**
     * @value View mode only applies to Content streams on the mobile app
     */
    VIEW_MODE_HELPER = 'ADMIN.CUSTOMER.STREAMS.VIEW_MODE_HELPER',
}
